import tmhRequest from '@/config/tmhRequest'

export default {
  searchListMenuClassify: function ( data) {
    return tmhRequest({
      url: '/menu/tmh/menuclassify/searchlistmenuclassify',
      method: 'post',
      params: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/menu/menuclassify.js